// PsyPractice: hukuki belgeler / Norsk (bokmål).
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Enkeltpersonforetak";

const OWNER = 'PsyPractice (heretter «Plattformen» eller «Behandlingsansvarlig»)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Bruksvilkår og ansvarsfraskrivelse",
    description:
      "Tjenestens art og grenser, hva den ikke erstatter, Brukerens forpliktelser og en omfattende ansvarsfraskrivelse som legger alt ansvar på Brukeren.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter og aksept",
        paras: [
          `Disse bruksvilkårene inngås mellom ${OWNER} og enhver fysisk eller juridisk person som får tilgang til eller bruker Plattformen («Brukeren»). Ved å opprette en konto, logge inn eller på noen måte bruke Plattformen bekrefter Brukeren å ha lest og forstått disse vilkårene og å akseptere og forplikte seg til dem i sin helhet og uten forbehold. Den som ikke aksepterer disse vilkårene, må ikke bruke Plattformen.`,
        ],
      },
      {
        heading: "2. Tjenestens art og grenser",
        bullets: [
          "PsyPractice er en AI-støttet programvare for pasientSIMULERING som lar psykologistudenter og klinikere tidlig i karrieren gjennomføre og registrere sin egen samtaleøvelse i trygge omgivelser.",
          "PsyPractice er ikke en utdannings- eller undervisningstjeneste; det er et programvareverktøy som lar brukeren gjennomføre og registrere sin egen øvelse. Plattformen tilbyr verken leksjoner, læreplan, eksamener eller dokumenter, og gir ingen tittel, kvalifikasjon eller autorisasjon av noe slag.",
          "Den simulerte «pasienten» er ikke en ekte klient; svarene er syntetisert av kunstig intelligens, kan være feilaktige, ufullstendige, selvmotsigende eller villedende, og gjør ikke krav på klinisk nøyaktighet eller sannhet.",
        ],
      },
      {
        heading: "2.1. Hva Plattformen ikke erstatter",
        bullets: [
          "Den er IKKE ekte terapi eller rådgivning, og den erstatter ingen økt gjennomført med en ekte klient.",
          "Den er IKKE en erstatning for klinisk veiledning. Tilbakemeldingsrapporter fra veileder-AI-en er automatisk generert tekst; de er verken en sakkyndig vurdering, en offisiell bedømmelse eller en karakter.",
          "Den er IKKE et diagnostisk instrument, et screeningverktøy eller et utredningsinstrument; ingen utdata fra Plattformen kan brukes til diagnostiske eller kliniske beslutninger om noen ekte person.",
          "Den MÅ IKKE brukes i kriser eller nødsituasjoner. Ved selvmordstanker, fare for skade på seg selv eller andre, eller enhver tilsvarende nødsituasjon, lukk Plattformen og kontakt umiddelbart den lokale nødetaten eller en kompetent helseinstitusjon.",
          "Den er IKKE en kilde til faglig kompetanse, autorisasjon, tittel eller myndighet; tid brukt på Plattformen og dens utdata kan ikke legges frem for noen institusjon som dokumentasjon på kvalifikasjoner.",
        ],
      },
      {
        heading: "3. Brukerens erklæringer og forpliktelser",
        bullets: [
          "Brukeren forplikter seg til å bruke Plattformen utelukkende innenfor lovlige og etiske rammer, med det formål å utvikle sin egen faglige praksis.",
          "Brukeren samtykker i IKKE å legge inn EKTE pasient-/klientdata, identifiserende opplysninger eller helseopplysninger i særlige kategorier som tilhører noen person; alle rettslige konsekvenser av dette påhviler utelukkende Brukeren.",
          "Brukeren forplikter seg til ikke å bruke noen utdata fra Plattformen til diagnostikk, behandling, intervensjon eller kliniske beslutninger som gjelder noen ekte person.",
          "Brukeren er alene ansvarlig for sin egen faglige kompetanse, sitt myndighetsområde og sin etterlevelse av gjeldende faglige og etiske regler.",
          "Kontosikkerhet, konfidensialitet om passordet og all aktivitet som utføres under Brukerens konto, er Brukerens ansvar.",
          "Kontoen er personlig; Brukeren forplikter seg til ikke å dele den med andre og ikke å bruke Plattformen ved hjelp av automatiserte midler (boter, skript osv.). Bruk av betalingsabonnementer er underlagt en grense for rimelig bruk (for tiden 60 økter per kalendermåned), som er nærmere beskrevet i fjernsalgsavtalen.",
        ],
      },
      {
        heading: "4. Alt ansvar påhviler Brukeren (ansvarsfraskrivelse)",
        paras: [
          "Plattformen leveres «SOM DEN ER» og «SOM TILGJENGELIG», uten noen som helst uttrykkelig eller underforstått garanti (herunder for uavbrutt drift, feilfrihet, egnethet til et bestemt formål, nøyaktighet eller aktualitet).",
          "Brukeren aksepterer og forplikter seg til å være UTELUKKENDE og PERSONLIG ansvarlig for ethvert direkte, indirekte, tilfeldig, særskilt eller avledet tap (herunder økonomisk tap, ikke-økonomisk skade, skade på faglig omdømme, datatap, inntektstap og skade påført tredjeparter) som oppstår som følge av Brukerens bruk av eller manglende mulighet til å bruke Plattformen, av å stole på AI-utdata, eller av å anvende slike utdata på noen måte.",
          "I den utstrekning gjeldende rett tillater det, GIR Brukeren herved ugjenkallelig og betingelsesløst AVKALL, nå og på forhånd, på ethvert krav, ethvert søksmål og enhver rett til erstatning som Brukeren måtte kunne reise mot Plattformen, dens eiere, ansatte, utviklere, forretningspartnere og tjenesteleverandører i anledning enhver skade Brukeren måtte bli utsatt for dersom et uheldig utfall inntreffer.",
          "Brukeren forplikter seg videre til å holde Plattformen fullt ut skadesløs for ethvert krav, ethvert tap, enhver bot og enhver kostnad (herunder advokatsalær) dersom Plattformen blir kontaktet av en tredjepart eller en institusjon som følge av Brukerens egen skyld, uaktsomhet eller bruk i strid med disse vilkårene.",
        ],
      },
      {
        heading: "5. Ansvarsbegrensning",
        paras: [
          "Uten at det berører ufravikelige bestemmelser i gjeldende rett, er Plattformens samlede rettslige ansvar under enhver omstendighet begrenset til det beløpet Brukeren faktisk har betalt til Plattformen i de 12 månedene forut for hendelsen som ga opphav til det aktuelle kravet. Ved gratis bruk er dette beløpet null.",
        ],
      },
      {
        heading: "6. Immaterielle rettigheter, endring og oppsigelse",
        bullets: [
          "Alle immaterielle rettigheter til Plattformen, dens programvare, design, pasientkasusmaler og innhold tilhører Plattformen.",
          "Alle overførbare økonomiske immaterielle rettigheter til innhold Brukeren skaper på Plattformen (herunder terapeutmeldingene Brukeren skriver, økttranskripsjoner og materiale avledet av dem) anses overdratt til Plattformen eksklusivt, uten tidsbegrensning og vederlagsfritt i det øyeblikket innholdet skapes; Plattformen kan bruke, reprodusere og behandle dette innholdet over hele verden og uten begrensning til ethvert formål, herunder drift av tjenesten, generering av tilbakemelding og forbedring og utvikling av systemet (herunder forbedring gjennom maskinlæring). Brukerens rettigheter knyttet til personopplysninger etter gjeldende personvernlovgivning (GDPR / KVKK) berøres ikke av denne overdragelsen og forblir forbeholdt.",
          "Plattformen forbeholder seg retten til å endre, suspendere eller avvikle disse vilkårene og tjenestens omfang når som helst, uten forhåndsvarsel.",
          "Ved brudd på disse vilkårene kan Plattformen suspendere eller stenge kontoen uten forhåndsvarsel.",
        ],
      },
      {
        heading: "7. Lovvalg og verneting",
        paras: [
          "Disse vilkårene er underlagt lovgivningen i Republikken Tyrkia. Domstolene og namsmyndighetene i Republikken Tyrkia har jurisdiksjon over enhver tvist som måtte oppstå.",
          "For forbrukere bosatt i Den europeiske union er vernet etter de ufravikelige forbrukervernreglene i bostedslandet og personvernrettighetene etter GDPR forbeholdt; dette lovvalget tilsidesetter ikke disse ufravikelige bestemmelsene.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Personvernerklæring",
    description:
      "GDPR som grunnstandard; behandlede opplysninger, rettslig grunnlag, hosting i EU, internasjonale overføringer (AI-leverandør) og KVKK artikkel 9 om overføring til utlandet for brukere i Tyrkia.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Denne personvernerklæringen forklarer hvordan personopplysninger behandles på Plattformen som drives av ${OWNER}. Som grunnstandard for personvern følger erklæringen EUs personvernforordning (GDPR / 2016/679); for brukere som befinner seg i Tyrkia, gjelder i tillegg den tyrkiske personopplysningsloven nr. 6698 (KVKK), særlig artikkel 9 om overføring til utlandet. KVKK-informasjonserklæringen og erklæringen om uttrykkelig samtykke er integrerte deler av denne erklæringen.`,
        ],
      },
      {
        heading: "Behandlingsansvarlig og hostingsted",
        bullets: [
          "Behandlingsansvarlig: PsyPractice. Henvendelser fra registrerte håndteres gjennom kontaktkanalen som er kunngjort på Plattformen (kontakt-e-post: info@psycora.com).",
          "Hosting: Plattformen og databasen dens driftes innenfor Den europeiske union, i et datasenter i Nederland (Oracle Cloud). For brukere i EU/EØS behandles og lagres opplysningene innenfor EU.",
          "Hostingleverandøren opptrer utelukkende som databehandler, i henhold til en inngått databehandleravtale (DPA).",
        ],
      },
      {
        heading: "Opplysninger som samles inn",
        bullets: [
          "Kontoopplysninger: navn, e-post, hashet passord, abonnements-/planinformasjon.",
          "Bruksopplysninger: opprettede økter, økttranskripsjoner, genererte pasientkasus, tilbakemeldingsrapporter fra veileder.",
          "Tekniske opplysninger: øktregistreringer, IP, nettleser-/språkpreferanse, logger for hastighetsbegrensning og sikkerhet.",
        ],
      },
      {
        heading: "Formål med behandlingen og rettslig grunnlag (GDPR art. 6)",
        bullets: [
          "Oppfyllelse av avtale (art. 6 nr. 1 bokstav b): opprettelse av konto, gjennomføring av økter, pasienthukommelse over flere økter, veiledervurdering, administrasjon av abonnement og bruksgrenser.",
          "Berettiget interesse (art. 6 nr. 1 bokstav f): sikkerhet, forebygging av misbruk, systemforbedring og feilsøking.",
          "Rettslig forpliktelse (art. 6 nr. 1 bokstav c): oppbevaring/rapportering som følger av lovgivning.",
          "Samtykke (art. 6 nr. 1 bokstav a): behandling for analyse/produktforbedring som ikke er strengt nødvendig for tjenesten, og, der det kreves, overføring ut av EU/EØS.",
        ],
      },
      {
        heading: "Internasjonale overføringer",
        paras: [
          "Fordi hostingen skjer innenfor EU (Nederland), behandles opplysningene til brukere i EU/EØS som hovedregel innenfor EU, uten overføring til tredjeland i dette laget. For å generere AI-svar overføres imidlertid øktinnhold og prompter til AI-tjenesteleverandøren (Anthropic), hvis behandlingsinfrastruktur kan befinne seg utenfor EU/EØS (f.eks. USA).",
          "Slike overføringer ut av EU/EØS bygger på nødvendige garantier etter GDPR art. 44 flg., særlig EU-kommisjonens standardkontraktsbestemmelser (SCC), og det inngås en databehandleravtale (DPA) med leverandøren. Plattformen selger IKKE personopplysninger til markedsføringsformål; opplysninger deles ikke med tredjeparter unntatt der det er strengt nødvendig for å drive tjenesten (lovlige anmodninger fra kompetente myndigheter forbeholdt).",
        ],
      },
      {
        heading: "For brukere i Tyrkia: KVKK art. 9 (overføring til utlandet)",
        paras: [
          "Personopplysningene til brukere som befinner seg i Tyrkia, overføres ut av Tyrkia fordi hostingen er i Nederland (EU), og kan i tillegg overføres til Anthropic for AI-behandling. Disse overføringene faller inn under KVKK art. 9 og bygger på nødvendige garantier (standardkontrakten/forpliktelseserklæringen publisert av Rådet) eller, der det kreves, på ditt uttrykkelige samtykke. Overføringens omfang, mottakere og formål er beskrevet i KVKK-informasjonserklæringen og erklæringen om uttrykkelig samtykke.",
        ],
      },
      {
        heading: "Den registrertes rettigheter (GDPR art. 15 til 22)",
        bullets: [
          "Innsyn, retting, sletting («retten til å bli glemt») og begrensning av behandlingen.",
          "Dataportabilitet: å motta opplysningene du har gitt, i et strukturert, alminnelig anvendt og maskinlesbart format.",
          "Innsigelse: å protestere mot behandling basert på berettiget interesse og mot direkte markedsføring.",
          "Rettigheter knyttet til utelukkende automatiserte individuelle avgjørelser/profilering.",
          "Å trekke samtykket tilbake når som helst for samtykkebasert behandling (tilbaketrekking påvirker ikke lovligheten av behandlingen frem til det tidspunktet).",
          "Retten til å klage til en tilsynsmyndighet: den relevante personvernmyndigheten i EU; Personopplysningsmyndigheten (KVKK) i Tyrkia.",
        ],
      },
      {
        heading: "Oppbevaring og sikkerhet",
        bullets: [
          "Opplysninger oppbevares så lenge behandlingsformålet krever det og i de periodene gjeldende lovgivning foreskriver; når perioden er utløpt, slettes eller anonymiseres de.",
          "Sensitive felt (f.eks. passord, bekreftelses- og tilbakestillingskoder) oppbevares kryptert/hashet; tilgangen er rettighetsstyrt.",
          "Siden ingen metode for overføring eller lagring er 100 % sikker, kan absolutt sikkerhet ikke garanteres.",
        ],
      },
      {
        heading: "Forbud mot ekte pasientdata",
        paras: [
          "Plattformen er en simuleringsprogramvare; det er forbudt å legge inn person-/helseopplysninger som tilhører ekte klienter. Alt ansvar som oppstår ved at Brukeren legger inn opplysninger i strid med dette forbudet, påhviler utelukkende Brukeren.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK-informasjonserklæring",
    description:
      "Behandlingsansvarlig, behandlingsformål, rettslig grunnlag, overføring og den registrertes rettigheter etter artikkel 10 i lov nr. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Behandlingsansvarlig",
        paras: [
          `I henhold til artikkel 10 i den tyrkiske personopplysningsloven nr. 6698 («KVKK») behandles personopplysningene dine av ${OWNER} i egenskap av Behandlingsansvarlig, innenfor rammen som beskrives nedenfor.`,
        ],
      },
      {
        heading: "Behandlede opplysninger og formål",
        bullets: [
          "Identitet/kontakt (navn, e-post): opprettelse av konto, autentisering, kommunikasjon.",
          "Kundetransaksjoner (abonnement, plan, bruk): levering av tjenesten, fakturering, håndheving av grenser.",
          "Transaksjonssikkerhet (økt, IP, logger): sikkerhet, forebygging av misbruk, rettslig forpliktelse.",
          "Brukerinnhold (økttranskripsjoner, genererte kasus): levering av programvaretjenesten og generering av tilbakemelding.",
          "Institusjonelt kullmedlemskap (kullidentifikator, medlemskapsperiode): der brukeren blir med i et kull drevet av en institusjon, instruktørinnsyn og administrasjon av kullet.",
        ],
      },
      {
        heading: "Rettslig grunnlag (art. 5)",
        bullets: [
          "Inngåelse/oppfyllelse av avtale: opplysninger som er nødvendige for å levere tjenesten.",
          "Behandlingsansvarliges berettigede interesse: sikkerhet, forebygging av svindel, systemforbedring.",
          "Rettslig forpliktelse: oppbevaring/rapportering som følger av lovgivning.",
          "Uttrykkelig samtykke: overføring til utlandet (art. 9) og tilleggsbehandling som ikke er strengt nødvendig for tjenesten.",
        ],
      },
      {
        heading: "Overføring til utlandet (art. 9)",
        paras: [
          "Fordi Plattformen og databasen dens driftes innenfor Den europeiske union, i et datasenter i Nederland (Oracle Cloud), overføres personopplysningene til brukere som befinner seg i Tyrkia, ut av Tyrkia (til EU). I tillegg kan øktinnhold og prompter, for å generere AI-svar, overføres til AI-tjenesteleverandøren (Anthropic), hvis behandlingsinfrastruktur kan befinne seg utenfor EU/EØS (f.eks. USA).",
          "Disse overføringene til utlandet faller inn under KVKK art. 9 og bygger på nødvendige garantier, slik som standardkontrakten/forpliktelseserklæringen publisert av Rådet, eller, der det kreves, på ditt uttrykkelige samtykke. Det inngås databehandleravtaler (DPA) med hosting- og tjenesteleverandørene.",
        ],
      },
      {
        heading: "Institusjonelle kull og instruktørinnsyn",
        paras: [
          "Hvis du blir med i et kull åpnet av et universitet, en klinikk eller en lignende institusjon, kan øktinnholdet ditt (transkripsjoner) og veilederrapportene dine ses av instruktøren for det kullet så lenge kullet varer. Dette innsynet omfatter bare øktene dine som er knyttet til kullet, og opphører når kullmedlemskapet ditt opphører.",
          "Denne tilgangen innhentes gjennom en SEPARAT skjerm for uttrykkelig samtykke som vises når du blir med i kullet; den er ikke en del av Plattformens generelle aksept. Hvis du ikke gir det samtykket, kan du ikke bli med i kullet, men du kan fortsette å bruke Plattformen individuelt nøyaktig som før. Tilbaketrekking av samtykket avslutter kullmedlemskapet ditt og lar den individuelle bruken din være upåvirket.",
        ],
      },
      {
        heading: "Den registrertes rettigheter (art. 11)",
        bullets: [
          "Å få vite om personopplysningene dine behandles, og i så fall å be om informasjon.",
          "Å få vite formålet med behandlingen og om de brukes i samsvar med det formålet.",
          "Å kjenne til tredjepartene opplysningene overføres til, innenlands eller i utlandet.",
          "Å be om retting av ufullstendig/uriktig behandling og, når vilkårene er oppfylt, sletting/destruksjon.",
          "Å protestere mot et resultat i din disfavør som utelukkende følger av automatisert analyse.",
          "Å kreve erstatning for skade lidt som følge av ulovlig behandling.",
        ],
      },
      {
        heading: "Henvendelser",
        paras: [
          "Du kan sende henvendelser om rettighetene dine gjennom kontaktkanalen kunngjort av Behandlingsansvarlig. Henvendelser avgjøres innenfor fristene som er fastsatt i KVKK og tilhørende forskrifter.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Erklæring om uttrykkelig samtykke",
    description:
      "Atskilt fra informasjonserklæringen; frivillig gitt samtykke til overføring til utlandet og AI-behandling.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Jeg erklærer at jeg har lest og forstått KVKK-informasjonserklæringen, og at jeg frivillig, informert og uttrykkelig samtykker til behandlingen som beskrives nedenfor. (I henhold til KVKK-rådets vedtak nr. 2018/90 innhentes uttrykkelig samtykke atskilt fra informasjonsplikten.)",
        ],
      },
      {
        heading: "Behandling det samtykkes til",
        bullets: [
          "Overføring av personopplysningene mine ut av Tyrkia, og lagring og behandling av dem der, fordi Plattformen driftes i Den europeiske union (Nederland / Oracle Cloud) (KVKK art. 9).",
          "Overføring og behandling av økttranskripsjonene og promptene mine hos AI-tjenesteleverandøren (Anthropic), hvis behandlingsinfrastruktur kan befinne seg utenfor EU/EØS, med det formål å generere AI-svar (KVKK art. 9).",
          "Behandling for produktforbedring og analyse som ikke er strengt nødvendig for å levere tjenesten.",
          "Mottak av tjenesterelaterte varsler.",
        ],
      },
      {
        heading: "Tilbaketrekking av samtykke",
        paras: [
          "Jeg forstår at jeg når som helst kan trekke tilbake mitt uttrykkelige samtykke; men siden overføring til utlandet til AI-leverandøren er teknisk nødvendig for at tjenesten skal fungere, aksepterer jeg at tilbaketrekking av dette samtykket kan føre til at jeg ikke kan bruke de aktuelle funksjonene eller tjenesten som helhet. Tilbaketrekking påvirker ikke lovligheten av behandlingen som er utført frem til datoen for tilbaketrekkingen.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice, see the comment there.
    id: "outreach",
    title: "Informasjon om henvendelser til institusjoner",
    description:
      "For akademikere og institusjonelle kontakter som har mottatt en e-posthenvendelse fra virksomheten: hvor opplysningene kom fra, hvorfor de behandles, det rettslige grunnlaget og hvordan man reserverer seg.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Denne erklæringen informerer mottakere av e-posthenvendelser som PsyPractice sender til psykologiske institutter ved universiteter og deres vitenskapelige ansatte, i samsvar med artikkel 10 i den tyrkiske personopplysningsloven nr. 6698 (KVKK) og kommunikeet om prosedyrer og prinsipper for oppfyllelse av informasjonsplikten. Fordi personopplysningene dine ikke ble innhentet direkte fra deg, gis informasjonen senest ved første kontakt, og det er derfor henvendelsen lenker hit.",
        ],
      },
      {
        heading: "1. Behandlingsansvarlig",
        bullets: [
          `Navn: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresse: ${MERCHANT.addressEn}`,
          `Skattekontor / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-post: ${MERCHANT.email}`,
          `Nett: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Behandlede opplysninger og kilden til dem",
        paras: [
          "Behandlingen er begrenset til faglige kontaktopplysninger: navn, akademisk tittel, universitet og institutt, institusjonell e-postadresse og, der den er publisert, institusjonelt telefonnummer.",
          "Disse opplysningene ble ikke samlet inn fra deg, men sammenstilt fra universitetenes offentlig publiserte offisielle institutt- og fakultetssider. Ingen særlige kategorier av opplysninger behandles, og private (ikke-institusjonelle) e-postadresser brukes ikke til henvendelser.",
        ],
      },
      {
        heading: "3. Formål",
        paras: [
          "Opplysningene dine behandles for å presentere et programvareverktøy utviklet for psykologifaget, for å invitere instituttet ditt til en mulig samtale om pilot eller samarbeid, og for å gjennomføre korrespondansen knyttet til dette. De brukes ikke til noe annet formål, selges ikke og overføres ikke til tredjeparter for markedsføring.",
        ],
      },
      {
        heading: "4. Rettslig grunnlag",
        paras: [
          "Behandlingen bygger på behandlingsansvarliges berettigede interesser etter artikkel 5/2-(f) KVKK, forutsatt at dette ikke skader dine grunnleggende rettigheter og friheter: kontakt skjer bare til en institusjonell adresse, bare om et tema som er direkte knyttet til mottakerens fagfelt, og et begrenset antall ganger.",
          "Det at opplysninger er offentlig tilgjengelige på nettet, er ikke i seg selv et rettslig grunnlag. Personopplysningsrådet har lagt til grunn at offentlig tilgjengelige opplysninger ikke kan brukes til ethvert formål, og at hensikten og formålet med offentliggjøringen må vurderes separat; artikkel 5/2-(d) påberopes derfor ikke.",
        ],
      },
      {
        heading: "5. Overføringer og oppbevaring",
        paras: [
          "Korrespondansen føres gjennom en e-postleverandør hvis infrastruktur kan befinne seg i utlandet; slike overføringer skjer med nødvendige garantier etter artikkel 9 KVKK.",
          "Opplysningene dine slettes når formålet med kontakten opphører, eller på din forespørsel. Etter en sletteforespørsel beholdes bare en strengt begrenset «ikke kontakt»-registrering, utelukkende for å sikre at du ikke kontaktes igjen; den brukes aldri til henvendelser.",
        ],
      },
      {
        heading: "6. Kommersielle elektroniske meldinger og retten til å avslå",
        paras: [
          "Markedsføringsmeldinger faller inn under lov nr. 6563 om regulering av elektronisk handel. Du kan avslå å motta dem uten å oppgi noen grunn; avslag behandles senest innen tre virkedager, og deretter sendes ingen flere markedsføringsmeldinger. Det er tilstrekkelig å svare på e-posten du mottok, eller å skrive til " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Dine rettigheter",
        paras: [
          "Etter artikkel 11 KVKK har du rett til å få vite om personopplysningene dine behandles, å be om informasjon om dem, å få vite formålet med behandlingen og om de brukes i samsvar med det, å kjenne til tredjepartene de overføres til i Tyrkia eller i utlandet, å be om retting av ufullstendige eller uriktige opplysninger, å be om sletting eller destruksjon, å be om at disse handlingene meddeles tredjeparter, å protestere mot et resultat i din disfavør som utelukkende følger av automatisert analyse, og å kreve erstatning for skade lidt.",
          `Henvendelser kan sendes til ${MERCHANT.email} og besvares senest innen tretti dager. Du beholder også retten til å klage til Personopplysningsrådet.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Retningslinjer for informasjonskapsler",
    description: "Typer informasjonskapsler som brukes, formålene deres og administrasjon av preferanser.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Plattformen bruker informasjonskapsler og lignende lokale lagringsteknologier (localStorage) for å opprettholde innloggingen din og huske preferansene dine.",
        ],
      },
      {
        heading: "Teknologier som brukes",
        bullets: [
          "Strengt nødvendige: økt-/autentiseringstoken, sikkerhet. Tjenesten fungerer ikke uten disse.",
          "Funksjonelle: språk-/regionpreferanse (NEXT_LOCALE), grensesnittpreferanser (f.eks. tema).",
          "Ytelse/sikkerhet: tekniske logger for hastighetsbegrensning og oppdagelse av misbruk.",
        ],
      },
      {
        heading: "Administrasjon av preferanser",
        paras: [
          "Du kan slette eller blokkere informasjonskapsler i nettleseren din; blokkering av strengt nødvendige informasjonskapsler vil imidlertid hindre innlogging og kjernefunksjonalitet. I tråd med prinsippene i GDPR / ePrivacy og KVKKs veileder om informasjonskapsler brukes ikke-nødvendige informasjonskapsler bare på grunnlag av din uttrykkelige preferanse/ditt samtykke.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Om oss",
    description:
      "PsyPractices formål, tjenesten det tilbyr, og kontaktopplysninger for selger.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice er en AI-støttet plattform for pasientsimulering og kliniske ferdigheter, utviklet for psykologistudenter og nyutdannede klinikere tidlig i karrieren. Brukerne gjennomfører tekstbaserte terapiøkter; ved slutten av hver økt vurderer en veileder-AI samtalen og utarbeider en utviklingsorientert tilbakemeldingsrapport. Pasient-AI-en fører den terapeutiske relasjonen videre økt for økt gjennom hukommelse på tvers av økter.",
        ],
      },
      {
        heading: "Vårt oppdrag",
        paras: [
          "Målet vårt er å gi fremtidige fagpersoner innen psykisk helse et trygt, repeterbart miljø der de kan øve på samtaleferdigheter uten noen risiko for å skade ekte klienter. PsyPractice er ikke en utdannings- eller undervisningstjeneste; det er et programvareverktøy som lar brukeren gjennomføre og registrere sin egen øvelse. Det er ikke ekte terapi eller rådgivning, det er ikke en erstatning for klinisk veiledning, det er ikke et diagnostisk instrument eller utredningsinstrument, og det må ikke brukes i kriser eller nødsituasjoner.",
        ],
      },
      {
        heading: "Hva vi tilbyr",
        bullets: [
          "Tekstbasert simulering av terapiøkter på tvers av ulike pasientprofiler syntetisert fra klinisk litteratur.",
          "Automatiserte veiledervurderingsrapporter etter hver økt.",
          "En «levende pasient»-modell med hukommelse på tvers av økter som utvikler den terapeutiske relasjonen over tid.",
          "Generering av egne pasienter, slik at studenter kan lage sine egne AI-kasus.",
          "Fremgangsmål som følger utviklingen av mikroferdigheter.",
        ],
      },
      {
        heading: "Selger-/virksomhetsinformasjon",
        bullets: [
          `Foretaksnavn: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresse: ${MERCHANT.addressEn}`,
          `Skattekontor / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-post: ${MERCHANT.email}`,
          `Nett: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Avtale om fjernsalg",
    description:
      "Vilkår om selger, kjøper, tjeneste, pris, betaling, oppfyllelse og angrerett etter den tyrkiske loven nr. 6502 og forskriften om fjernsalgsavtaler.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter",
        bullets: [
          `SELGER: ${MERCHANT.legalName} (${OWNER_TYPE}). Adresse: ${MERCHANT.addressEn}. Skattekontor/nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-post: ${MERCHANT.email}.`,
          "KJØPER: den fysiske eller juridiske personen som oppretter en konto på Plattformen og kjøper et betalt abonnement («Kjøperen»).",
        ],
      },
      {
        heading: "2. Avtalens gjenstand",
        paras: [
          "Gjenstanden for denne avtalen er å fastsette partenes rettigheter og plikter, i samsvar med den tyrkiske loven nr. 6502 om forbrukervern og forskriften om fjernsalgsavtaler, når det gjelder salget og oppfyllelsen av abonnementet på den digitale tjenesten som Kjøperen har kjøpt elektronisk gjennom Plattformen, og hvis egenskaper og salgspris er angitt nedenfor.",
        ],
      },
      {
        heading: "3. Tjenestens art og pris",
        bullets: [
          "Tjenesten som selges, er de AI-støttede pasientsimuleringsfunksjonene som tilbys under en betalt abonnementsplan for programvaren PsyPractice (en digital tjeneste / rett til å bruke programvaren).",
          "PsyPractice er ikke en utdannings- eller undervisningstjeneste; det er et programvareverktøy som lar brukeren gjennomføre og registrere sin egen øvelse. Abonnementsavgiften er vederlag for tilgang til den programvaren; den er ikke betaling for leksjoner, læreplan, eksamener, rådgivning eller noe dokument.",
          "Abonnementets innhold, varighet (månedlig, en periode på 4 måneder eller årlig) og gjeldende pris vises tydelig på Plattformens pris-/betalingsside ved kjøpstidspunktet; totalbeløpet inkludert avgifter opplyses Kjøperen før betaling.",
          "Prisene gjelder i valutaen som vises på Plattformen; med mindre abonnementet sies opp, fornyes det automatisk til samme pris ved utløpet av den valgte perioden.",
          "For abonnementer som tilbys som «ubegrensede økter», er bruken underlagt en grense for rimelig bruk (for tiden 60 økter per kalendermåned). Når grensen er nådd, kan nye økter startes igjen fra den første dagen i påfølgende kalendermåned; dette gir ikke rett til prisavslag eller refusjon. Grensen skal hindre kontodeling og automatisert bruk, og Selgeren endrer den ikke til ugunst for Kjøperen i en betalt abonnementsperiode.",
        ],
      },
      {
        heading: "4. Betaling",
        paras: [
          "Betalinger innkreves sikkert med kreditt-/debetkort gjennom den lisensierte betalingsinstitusjonen iyzico. Kortopplysninger lagres ikke av Selger; betalingen behandles gjennom iyzicos sikre systemer. Ved gjentakende (abonnements)betalinger belastes beløpet automatisk hver fornyelsesperiode på kortet Kjøperen har godkjent.",
        ],
      },
      {
        heading: "5. Oppfyllelse og levering",
        paras: [
          "Tjenesten er digital og innebærer ingen fysisk levering. Ved bekreftelse av betalingen gjøres abonnementsfunksjonene umiddelbart tilgjengelige i Kjøperens konto. Oppfyllelsen skjer elektronisk ved å gi uavbrutt tilgang gjennom hele abonnementsperioden.",
        ],
      },
      {
        heading: "6. Angrerett og unntak fra den",
        bullets: [
          "I henhold til artikkel 15/1-(ğ) i forskriften om fjernsalgsavtaler kan angreretten ikke benyttes for immaterielle (digitale) varer/tjenester som ytes umiddelbart i elektronisk form, der oppfyllelsen har begynt med Kjøperens samtykke.",
          "Kjøperen erkjenner på kjøpstidspunktet at tjenesten ytes umiddelbart, og at det derfor ikke foreligger noen angrerett. Kjøperen kan når som helst si opp abonnementet for å stanse fornyelsen; oppsigelsen får virkning ved utløpet av den gjeldende betalte perioden.",
          "For detaljerte refusjonsvilkår, se «Leverings- og refusjonsvilkår».",
        ],
      },
      {
        heading: "7. Tvister og ikrafttredelse",
        paras: [
          "Ved tvist kan Kjøperen henvende seg til forbrukervoldgiftsnemnda eller forbrukerdomstolene på sitt bosted innenfor beløpsgrensene kunngjort av Handelsdepartementet. Denne avtalen inngås og trer i kraft ved Kjøperens godkjenning i elektronisk form.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Leverings- og refusjonsvilkår",
    description:
      "Levering av den digitale tjenesten, oppsigelse av abonnement, unntaket fra angreretten og refusjonsvilkår.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Levering (digital tjeneste)",
        bullets: [
          "PsyPractice er en helt digital tjeneste; det er ingen forsendelse av fysiske produkter eller budlevering.",
          "I det øyeblikket betalingen bekreftes, aktiveres abonnementsfunksjonene automatisk og umiddelbart i Kjøperens konto; det er ingen egen leveringstid eller leveringsavgift.",
          "Tjenesten nås via nettleseren på enhver enhet med internettilkobling.",
        ],
      },
      {
        heading: "Oppsigelse av abonnement",
        bullets: [
          "Kjøperen kan når som helst si opp abonnementet fra kontoinnstillingene. Oppsigelsen får virkning ved utløpet av den gjeldende betalte perioden og stanser neste automatiske fornyelse.",
          "Etter oppsigelse fortsetter tilgangen til tjenesten ut resten av den betalte perioden.",
        ],
      },
      {
        heading: "Angrerett og refusjon",
        bullets: [
          "Fordi tjenesten er en digital tjeneste som ytes umiddelbart med Kjøperens samtykke, oppstår det som hovedregel ingen angrerett, og dermed ingen refusjonsrett, etter artikkel 15/1-(ğ) i forskriften om fjernsalgsavtaler.",
          "Ved klar mangel, slik som feilaktig/dobbel belastning, fullstendig manglende mulighet til å få tilgang til tjenesten av tekniske årsaker eller lignende, kan Kjøperen be om refusjon ved å kontakte Selger innen rimelig tid fra betalingsdatoen.",
          `Refusjonsforespørsler sendes til ${MERCHANT.email}; godkjente refusjoner tilbakeføres til kortet som ble brukt til betalingen, gjennom iyzicos infrastruktur, som hovedregel innen 14 dager. Refusjonstiden kan variere avhengig av bankens behandlingstid.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `For alle spørsmål om levering, oppsigelse og refusjon: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
